module.exports = __webpack_public_path__ + "static/media/2020.Security.Tsai.Civet.69567030.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/2020.Security.Tsai.Civet.pdf
// module id = 68
// module chunks = 0